import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, Loading, LoadingController, Navbar } from 'ionic-angular';
import { User } from '../../providers';
import { ScoreDetailPage } from '../score-detail/score-detail';
import { FirstPage } from '../first/first';

/**
 * Generated class for the ResultadosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-resultados',
  templateUrl: 'resultados.html',
})
export class ResultadosPage {

  @ViewChild(Navbar) navBar: Navbar;

  count;
  private loginErrorString: string;

  obj_economicas: any = {};
  obj_juridicas: any = {};
  obj_educacion: any = {};
  obj_comunicacion: any = {};
  obj_teologia: any = {};
  obj_ingenieria: any = {};
  obj_medicas: any = {};
  obj_psicologicas: any = {};
  obj_sociales: any = {};

  loading: Loading;

  desc_view = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public user: User, public alertCtrl: AlertController, public toastCtrl: ToastController, public loadingController: LoadingController) {

    this.loading = this.loadingController.create({content : "Cargando, porfavor espera un momento..."});
    this.loading.present();

    this.count = 0;
    console.log("count: "+this.count);

    this.desc_view = false;

    try {

    /* economicas */
    var urlec = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias Empresariales (Económicas)");

    this.user.getFacultyFinalScore(urlec, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_economicas = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* economicas */

    /* juridicas */
    var urlju = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias Jurídicas y Justicia");

    this.user.getFacultyFinalScore(urlju, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_juridicas = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* juridicas */

    /* educacion */

    var urled = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias de la Educación");

    this.user.getFacultyFinalScore(urled, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_educacion = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* educacion */


    /* comunicacion */

    var urlco = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias de la Comunicación");

    this.user.getFacultyFinalScore(urlco, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_comunicacion = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* comunicacion */

    /* teologia */

    var urlte = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Teología");

    this.user.getFacultyFinalScore(urlte, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_teologia = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* teologia */

    /* ingenieria */

    var urlin = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ingeniería y Ciencias Aplicadas");

    this.user.getFacultyFinalScore(urlin, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_ingenieria = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });
    /* ingenieria */

    /* medicas */

    var urlme = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias Médicas y Salud");

    this.user.getFacultyFinalScore(urlme, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_medicas = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* medicas */

    /* psicologia */

    var urlps = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias Psicológicas");

    this.user.getFacultyFinalScore(urlps, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_psicologicas = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* psicologia */

    /* sociales */

    var urlso = "accounts/getFacultyFinalScore?access_token=".concat(this.navParams.get("token")).concat("&id="+this.navParams.get("user")).concat("&facultad=Ciencias Sociales");

    this.user.getFacultyFinalScore(urlso, {}).subscribe((resp) => {
      console.log("result: "+JSON.stringify(resp));
      console.log("jsonresult: "+JSON.stringify(resp["data"]));
      this.obj_sociales = resp["data"];
      this.count = this.count + 1;
      console.log("count: "+this.count);
      this.validateCount();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server

      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
      });
      toast.present();
    });

    /* sociales */

    } catch(err){
      console.log('Error: '+err);
      this.loading.dismissAll();
    }
  }

  validateCount() {
    if(this.count == 9) {
      this.loading.dismissAll();
      return true;
    }
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

  showDescription(facultad: string, score: string, interpretacion: string) {

    this.desc_view = true;

    console.log("facultad: "+facultad);
    console.log("score: "+score);
    console.log("interpretacion: "+interpretacion);

    this.navCtrl.push(ScoreDetailPage,
      {
        description : {
          interpretacion: interpretacion,
          facultad: facultad,
          score: score
        }
      });
  }

  ionViewDidAppear() {
    console.log("ionViewDidAppear");
  }

  ionViewWillDisappear() {
    console.log("ionViewWillDisappear");
  }

  ionViewDidLeave() {
    console.log("ionViewDidLeave");
    console.log("desc_view: "+this.desc_view);

    /*
    if(this.navParams.get("from_test")){
      if(this.desc_view){
        console.log("GO TO DESCRIPTION");
      } else {
        console.log("RETURN TO ROOT");
        this.returnRoot();
      }
    }

    if(!this.navParams.get("from_test")) {
      if(this.desc_view){
        console.log("GO TO DESCRIPTION");
      } else {
        console.log("RETURN TO ROOT");
        this.returnRoot();
      }
    }
    */
    /*
      let status: number;
      status = 2;

      this.navCtrl.setRoot(FirstPage,
        {
          user : {
            userId: this.navParams.get("user"),
            id: this.navParams.get("token") ,
            user: {
              firstname: '',
              teststatus: status
            }
          }
        });
      this.navCtrl.popToRoot();
      */
    }

    returnRoot() {
      let status: number;
      status = 2;

      this.navCtrl.setRoot(FirstPage,
        {
          user : {
            userId: this.navParams.get("user"),
            id: this.navParams.get("token") ,
            user: {
              firstname: '',
              teststatus: status
            }
          }
        });
      this.navCtrl.popToRoot();
    }

    ionViewDidLoad() {
      this.navBar.backButtonClick = () => {
        // you can set a full custom history here if you want
          let status: number;
          status = 2;
          this.navCtrl.setRoot(FirstPage,
            {
              user : {
                userId: this.navParams.get("user"),
                id: this.navParams.get("token") ,
                user: {
                  firstname: '',
                  teststatus: status
                },
                mail: this.navParams.get('mail')
              }
            });

        this.navCtrl.popToRoot();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/resultados/resultados.ts